import type { ThemeId } from '@/js/libs/ui/src/V2/Palette';

export const PREFERS_DARK_QUERY = '(prefers-color-scheme: dark)' as const;

export const THEME_SETTINGS = ['primary', 'primaryDark', 'system'] as const;
export type ThemeSetting = (typeof THEME_SETTINGS)[number];

export const isThemeSetting = (val: unknown): val is ThemeSetting =>
  typeof val === 'string' && (THEME_SETTINGS as readonly string[]).includes(val);

export const parseThemeSetting = (val: unknown): ThemeSetting | null => (isThemeSetting(val) ? val : null);

export function checkPrefersDark(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(PREFERS_DARK_QUERY).matches;
  } catch {
    return false;
  }
}

export function resolveThemeId(setting: ThemeSetting | null): ThemeId {
  if (setting === 'system') return checkPrefersDark() ? 'primaryDark' : 'primary';
  if (setting === 'primary' || setting === 'primaryDark') return setting;
  return 'primary';
}

export function applyThemeToDom(themeId: ThemeId, metaThemeColor: string): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  root.setAttribute('data-theme', themeId);

  let meta = document.querySelector('meta#theme-color-runtime[name="theme-color"]') as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.id = 'theme-color-runtime';
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', metaThemeColor);
}
